<script>
    export default {
        name: 'Pagetabs',
        data() {
            return {
               tabOpen: '',
               mobileOpen: false
            };
        },
        methods: {
            openTab(tabId) {
                if (tabId === this.tabOpen) {
                    this.tabOpen = '';
                } else {
                    this.tabOpen = tabId;
                }
                this.mobileOpen = false;
            },
            toggleMobile() {
                this.mobileOpen = !this.mobileOpen;
            }
        },
    };
</script>
